<scitis-app-global-page-header [pageTitle]="'Machines'">
</scitis-app-global-page-header>

<div class="card mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
          <tr>
            <th scope="col" class="sortable" sortable="type" (sort)="onColumnSort($event)"><span translate>Display name</span></th>
            <th scope="col" class="sortable" sortable="name" (sort)="onColumnSort($event)"><span translate>Name</span></th>
            <th scope="col" class="sortable" sortable="location" (sort)="onColumnSort($event)"><span translate>Location</span></th>
            <th scope="col" class="sortable" sortable="category" (sort)="onColumnSort($event)"><span translate>Category</span></th>
          </tr>
        </thead>
        <tbody>
          @for (machine of machines; track machine) {
            <tr>
              <td>
                <strong [innerText]=" machine.type"></strong>
              </td>
              <td [innerText]=" machine.name"></td>
              <td [innerText]=" machine.location"></td>
              <td [innerText]=" machine.category | translate"></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<scitis-page-summary [itemsCount]="machines.length"
  [singleItemText]="translate.instant('Machine')"
  [multipleItemsText]="translate.instant('Machines')">

</scitis-page-summary>
